import { Component, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { BatchModel } from "src/app/model/BatchModel";
import { ExportImportService } from "src/app/services/export-import.service";

@Component({
  selector: "app-secure-export-photos",
  templateUrl: "./export-photos.component.html",
  styleUrls: ["./export-photos.component.scss"],
})
export class ExportPhotosComponent implements OnInit {
  isLoading = false;
  form: FormGroup = new FormGroup({});
  lotteryList: {[key: number]: string};
  batches: BatchModel[];
  isSubmitDisabled: boolean = false;
  lotteryKey: number;
  downloadedBatches: string[] = [];
  
  constructor(
    private router: Router,
    private exportImportService: ExportImportService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.isLoading = true;
    this.exportImportService.initExportPhotosForm()
    .subscribe((data) => {
        this.lotteryList = data.lotteryList;
        this.isLoading = false;
      },
      (error) => {
        this.exportImportService.errorToast(error?.error?.message || error?.error?.errorMessage);
        this.isLoading = false;
      }
    );
  }

  onChange(e) {
    console.log(e);
    if(e.value) {
      this.isLoading = true;
      this.exportImportService.fetchBatchWiseLotteryPhotos(e.value?.key)
      .subscribe((data) => {
        this.lotteryKey = e.value?.key;
        this.isLoading = false;
        this.batches = data;
      }, error => {
        this.isLoading = false;
        this.exportImportService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
      });    
    }
  }

  refresh() {
    this.loadData();
  }

  showDone(batchName) {
    return this.downloadedBatches?.indexOf(batchName) >= 0;
  }

  downloadPhotos(batchName: string, start: number, end: number){
    this.isLoading = true;
    if(this.downloadedBatches.indexOf(batchName) >= 0) {
      this.downloadedBatches.splice(this.downloadedBatches.indexOf(batchName), 1);
    }
    this.exportImportService.downloadPhotos(this.lotteryKey, batchName, start, end)
    .subscribe((data) => {
      this.isLoading = false;
      this.isLoading = false;
      if(data.status === 'SUCCESS') {
        this.downloadedBatches.push(batchName);
        this.downloadFile(data.base64File, data.fileName);
      }
      else {
        this.exportImportService.errorToast(data.errorMessage);  
      }
    }, error => {
      this.isLoading = false;
      this.exportImportService.errorToast(error?.error?.message||error?.errorMessage||error?.error?.errorMessage);
    });
  }

  downloadFile(base64:string | ArrayBuffer, fileName:string){
    const src = `${base64}`;
    const link = document.createElement("a")
    link.href = src
    link.download = fileName
    link.click()
    
    link.remove()
  }
}